import { render, staticRenderFns } from "./MealsFilterDropdown.vue?vue&type=template&id=2ead126e&scoped=true&"
import script from "./MealsFilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./MealsFilterDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./MealsFilterDropdown.vue?vue&type=style&index=0&id=2ead126e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead126e",
  null
  
)

export default component.exports